
class CartUpsellModal {
  constructor() {
    this.modal = document.getElementById('UpsellSheet');
    if (!this.modal) return;

    this.closeButtons = this.modal.querySelectorAll('[data-action="close"]');
    this.loader = this.modal.querySelector('.upsell-sheet__loading');
    this.titleEl = document.getElementById('UpsellSheet-Title');
    this.sizeEl = document.getElementById('UpsellSheet-Size');
    this.descEl = document.getElementById('UpsellSheet-Description');
    this.discountMsgEl = document.getElementById('UpsellSheet-DiscountMessage');
    this.priceContainer = document.getElementById('UpsellSheet-Price');
    this.priceCurrentEl = this.priceContainer.querySelector('.price-current');
    this.priceOriginalEl = this.priceContainer.querySelector('.price-original');
    this.variantIdEl = document.getElementById('UpsellSheet-VariantId');
    this.addButton = document.getElementById('UpsellSheet-AddButton');

    this.imageContainer = document.getElementById('UpsellSheet-ImageContainer');
    this.skeletonEl = this.imageContainer.querySelector('.upsell-sheet__skeleton');

    this.currentSlide = 0;

    this.carousel = document.getElementById('UpsellCarousel');
    this.carouselTrack = document.getElementById('UpsellCarousel-Track');
    this.carouselPrev = document.getElementById('UpsellCarousel-Prev');
    this.carouselNext = document.getElementById('UpsellCarousel-Next');
    this.carouselDots = document.getElementById('UpsellCarousel-Dots');
    
    this.currentSlide = 0;
    this.totalSlides = 0;

    this.text = {
      addToCart: this.upsellAddButton?.dataset.addText || 'Add to cart',
      added: this.upsellAddButton?.dataset.addedText || 'Added',
      adding: this.upsellAddButton?.dataset.addingText || 'Adding...'
    };

    
    this.moneyFormat = this.addButton?.dataset.moneyFormat || '₹{{amount}}';
    this.moneyFormat = this.moneyFormat.replace('{{amount}}', '{AMOUNT}');

    this.init();
  }

  init() {
    this.closeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    this.carouselPrev.addEventListener('click', () => this.prevSlide());
    this.carouselNext.addEventListener('click', () => this.nextSlide());

    window.addEventListener('popstate', (event) => {
      if (this.modal.getAttribute('aria-hidden') === 'false') {
        this.close(false);
      }
    });

    this.addButton.addEventListener('click', async (e) => {
      e.preventDefault();
      if (this.addButton && !this.addButton.disabled) {
        const addText = this.text.addToCart;
        const addingText = this.text.adding;
        const addedText = this.text.added;
        
        this.addButton.disabled = true;
        this.addButton.classList.add('loading');
        console.log('Adding upsell item...');
        this.addButton.textContent = addingText;

        this.addToCart(this.addButton, this.variantIdEl.value, addText, addingText, addedText);

        return;
      }
    });
  }

  async addToCart(addButton, variantId, addText, addingText, addedText) {
    // try {
      const response = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      const responseData = await response.json();
      if (!response.ok) {
        throw new Error(responseData.description || 'An error occurred.');
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { 
          source: 'cart-upsell-add', 
          cartData: responseData,
          variantId: variantId 
        });
      } else {
        console.error('publish or PUB_SUB_EVENTS not defined. Reloading.');
        window.location.reload(); // Fallback
      }
      
      addButton.classList.remove('loading');
      addButton.classList.add('is-added');
      addButton.textContent = addedText;

    // } catch (error) {
    //   console.error('Error adding upsell item:', error);
    //   addButton.disabled = false;
    //   addButton.classList.remove('loading');
    //   addButton.textContent = 'Error!';
    //   setTimeout(() => {
    //     addButton.textContent = addText;
    //   }, 3000);
    // }
  }

  async open(handle, variantId, showDiscount, discountAmount, discountThreshold, cartTotal) {
    this.lastFocusedElement = document.activeElement;

    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.clearContent();

    try {
      const [cartResponse, productResponse] = await Promise.all([
        fetch('/cart.js'),
        fetch(`/products/${handle}.js`)
      ]);
      
      const cart = await cartResponse.json();
      const product = await productResponse.json();

      this.populateContent(product, variantId, showDiscount, discountAmount, discountThreshold, cart.total_price, cart);

      if (this.closeButtons.length > 0) {
        this.closeButtons[0].focus();
      }

    } catch (e) {
      console.error('Failed to fetch product or cart data:', e);
      this.close();
    }
  }

  close(updateHistory = true) {
    // Move focus safely
    if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
      this.lastFocusedElement.focus();
    } else {
      document.body.focus();
    }

    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    this.clearContent();
  }

  clearContent() {
    this.carousel.style.display = 'none';
    this.carouselTrack.innerHTML = '';
    this.skeletonEl.classList.remove('is-hidden');
    this.currentSlide = 0;
    this.totalSlides = 0;

    this.titleEl.innerHTML = '<span class="skeleton-text" style="width: 80%;"></span>';
    this.sizeEl.innerHTML = '<span class="skeleton-text" style="height: 0.8rem; width: 30%;"></span>';
    
    this.descEl.innerHTML = `
      <span class="skeleton-text"></span>
      <span class="skeleton-text"></span>
      <span class="skeleton-text skeleton-text--short"></span>
    `;
    
    this.priceCurrentEl.innerHTML = '<span class="skeleton-text skeleton-text--price"></span>';
    this.priceOriginalEl.innerHTML = '';
    this.priceOriginalEl.style.display = 'none';
    
    this.discountMsgEl.style.display = 'none';
    this.variantIdEl.value = '';
    this.addButton.disabled = true;
    this.addButton.textContent = this.text.add;
  }

  populateContent(product, variantId, showDiscount, discountAmount, discountThreshold, cartTotal, cart) {
    const variant = product.variants.find(v => v.id == variantId) || 
                    product.variants.find(v => v.available) || 
                    product.variants[0];
    
    if (!variant) {
      console.error('No variant found for product.');
      this.close();
      return;
    }

    this.titleEl.textContent = product.title;
    if (variant.title !== 'Default Title') {
      this.sizeEl.textContent = `(${variant.title})`;
    } else {
      this.sizeEl.textContent = '';
    }
    this.variantIdEl.value = variant.id;

    // NEW: Setup carousel with images
    this.setupCarousel(product, variant);

    this.descEl.innerHTML = product.description;

    let currentPrice = Math.trunc(variant.price);
    let originalPrice = Math.trunc(variant.compare_at_price) || currentPrice;

    if (showDiscount) {
      currentPrice = variant.price - discountAmount;
      originalPrice = variant.price;
      this.discountMsgEl.textContent = `You've unlocked ${this.formatMoney(discountAmount)} off!`;
      this.discountMsgEl.style.display = 'block';
    } else if (cartTotal < discountThreshold) {
      const remaining = discountThreshold - cartTotal;
      this.discountMsgEl.textContent = `Spend ${this.formatMoney(remaining)} more to get ${this.formatMoney(discountAmount)} off this item.`;
      this.discountMsgEl.style.display = 'block';
    } else {
      this.discountMsgEl.style.display = 'none';
    }

    this.priceCurrentEl.textContent = this.formatMoney(currentPrice);
    if (originalPrice > currentPrice) {
      this.priceOriginalEl.textContent = this.formatMoney(originalPrice);
      this.priceOriginalEl.style.display = 'inline';
    } else {
      this.priceOriginalEl.style.display = 'none';
    }

    const isAdded = cart.items.some(item => item.variant_id == variant.id);
    
    this.addButton.disabled = isAdded;
    this.addButton.textContent = isAdded 
      ? this.text.added 
      : `${this.text.addToCart} - ${this.formatMoney(currentPrice)}`;
  }

  setupCarousel(product, variant) {
    const images = product.images || [];
    
    if (images.length === 0) {
      images.push(product.featured_image);
    }

    this.totalSlides = images.length;
    
    this.carouselTrack.innerHTML = '';
    this.carouselDots.innerHTML = '';

    images.forEach((imageSrc, index) => {
      const slide = document.createElement('div');
      slide.className = 'upsell-carousel__slide';
      
      const img = document.createElement('img');
      img.alt = `${product.title} - Image ${index + 1}`;
      img.height = 'auto';
      img.width = '100%';
      
      if (index === 0) {
        img.src = imageSrc.replace(/(\.[^.]*)$/, '_500x$1');
        img.onload = () => {
          img.classList.add('is-loaded');
          this.skeletonEl.classList.add('is-hidden');
          this.carousel.style.display = 'block';
        };
      } else {
        img.dataset.src = imageSrc.replace(/(\.[^.]*)$/, '_500x$1');
        
        setTimeout(() => {
          img.src = img.dataset.src;
          img.onload = () => img.classList.add('is-loaded');
        }, 100 * index);
      }
      
      slide.appendChild(img);
      this.carouselTrack.appendChild(slide);

      const dot = document.createElement('button');
      dot.className = 'upsell-carousel__dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      if (index === 0) dot.classList.add('is-active');
      dot.addEventListener('click', () => this.goToSlide(index));
      this.carouselDots.appendChild(dot);
    });

    if (images.length > 1) {
      this.carouselPrev.style.display = 'flex';
      this.carouselNext.style.display = 'flex';
    } else {
      this.carouselPrev.style.display = 'none';
      this.carouselNext.style.display = 'none';
    }

    this.updateCarousel();
  }

  prevSlide() {
    this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    this.updateCarousel();
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    this.updateCarousel();
  }

  goToSlide(index) {
    this.currentSlide = index;
    this.updateCarousel();
  }

  updateCarousel() {
    const offset = -this.currentSlide * 100;
    this.carouselTrack.style.transform = `translateX(${offset}%)`;

    const dots = this.carouselDots.querySelectorAll('.upsell-carousel__dot');
    dots.forEach((dot, index) => {
      if (index === this.currentSlide) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }

  async updateThemeCart(cart) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      publish(PUB_SUB_EVENTS.cartUpdate, { 
        source: 'cart-upsell',
        cartData: cart
      });
    } else {
      console.warn('Dawn pub/sub system not found. Manually updating cart count and dispatching custom event.');
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));

      const cartCountElements = document.querySelectorAll('.cart-count-bubble, [data-cart-count], #cart-icon-bubble');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
    }
  }

  updateCardButtons(cart) {
    document.querySelectorAll('.js-upsell-add-button').forEach(button => {
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      if (cart.items) {
        const isAdded = cart.items.some(item => item.variant_id == variantId);
        
        button.disabled = isAdded;
        if (isAdded) {
          button.classList.add('is-added');
          button.textContent = this.text.added;
        } else {
          button.classList.remove('is-added');
          button.textContent = this.text.addToCart;
        }
      }
    });
  }

  updateModalButtonState(cart) {
    if (this.modal.getAttribute('aria-hidden') === 'true') {
      return;
    }
    
    const variantId = this.variantIdEl.value;
    if (!variantId) return;
    
    const isAdded = cart.items.some(item => item.variant_id == variantId);
    
    if (isAdded) {
      this.addButton.disabled = true;
      this.addButton.textContent = this.text.added;
    }
  }

  formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = Math.trunc(cents / 100);
    console.log(this.moneyFormat)
    return this.moneyFormat.replace('{AMOUNT}', value);
  }
}

// document.addEventListener('DOMContentLoaded', () => {
//   function initializeUpsell() {
//     new CartUpsellModal();
//   }

//   if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
//     initializeUpsell();
//   } else {
//     let attempts = 0;
//     const interval = setInterval(() => {
//       attempts++;
//       if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
//         clearInterval(interval);
//       } else if (attempts > 50) {
//         console.warn('Cart Upsell: Timed out waiting for theme pub/sub. Initializing with fallback listener.');
//         clearInterval(interval);
//       }
//     }, 100);
//   }
// });
